import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { UserService } from 'src/app/core/services/user.service';
import { Router } from '@angular/router';

export const OnboardingGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);
  
  return userService.getProfile(false).pipe(
    map(user => {
      const onboardingComplete = user?.user_metadata?.onboarding_complete;
      const isOnboardingRoute = state.url.startsWith('/onboarding');

      if (isOnboardingRoute) {
        if (onboardingComplete) {
          // Already onboarded: redirect away from onboarding pages
          router.navigate(['/patients']);
          return false;
        } else {
          // Not onboarded: allow access to onboarding pages
          return true;
        }
      } else {
        // For main app routes: require onboarding to be complete
        if (onboardingComplete) {
          return true;
        } else {
          router.navigate(['/onboarding']);
          return false;
        }
      }
    })
  );
};